export default function CompletedAuditDirective() {
  return {
    template: require('./completed-audit.html'),
    scope: {
      audit: '='
    },
    controller: 'CompletedAuditController',
    controllerAs: 'completedAuditVM',
    bindToController: true,
    replace: true
  };
}
